import { Switch, Redirect, Route, useRouteMatch } from 'peach/router'

import PersonInteraction from './PersonInteraction'
import PersonInteractions from './PersonInteractions'

const PersonInteractionRoutes = () => {
  const { path, url } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <PersonInteractions />
      </Route>
      <Route path={`${path}/:interactionId`}>
        <PersonInteraction />
      </Route>
      <Redirect to={url} />
    </Switch>
  )
}

export default PersonInteractionRoutes
